<div class="si-wrapper">
  <div class="si-card">

    <!-- Logo -->
    <div class="si-logo">
      <a *ngIf="reseller?.image" [class.pointer]="reseller.link" (click)="goToOf()">
        <img [src]="reseller.image | resellerImage" alt="logo" />
      </a>
      <a *ngIf="!reseller?.image" (click)="pageSrv.redirectToFront()" class="pointer">
        <img src="assets/images/logo-by-wefit.png" alt="WeFit" />
      </a>
    </div>

    <!-- Title -->
    <div class="si-title" translate>Connexion</div>
    <div class="si-subtitle" translate>Accède à ton espace Serious GAME</div>

    <!-- Expired session alert -->
    <div *ngIf="params?.displayExpiredSessionMessage" class="si-alert">
      <i class="fa-solid fa-circle-info"></i>
      <span translate>Votre session a expirée. Merci de vous reconnecter pour continuer.</span>
    </div>

    <!-- Form -->
    <form [formGroup]="form" (submit)="onSubmit()" class="si-form">

      <div class="si-field">
        <label class="si-label" translate>Email</label>
        <div class="si-input-wrap">
          <i class="fa-regular fa-envelope si-input-icon"></i>
          <input
            type="text"
            formControlName="login"
            class="si-input"
            placeholder="nom@exemple.com"
            autocomplete="email" />
        </div>
      </div>

      <div class="si-field">
        <div class="si-label-row">
          <label class="si-label" translate>Mot de passe</label>
          <a
            *ngIf="!reseller?.notSendMail"
            [routerLink]="['/', langSrcSrv.current.shortCode, 'auth', 'recovery']"
            class="si-forgot"
            translate>
            Mot de passe oublié ?
          </a>
        </div>
        <div class="si-input-wrap">
          <i class="fa-solid fa-lock si-input-icon"></i>
          <input
            [type]="showPassword ? 'text' : 'password'"
            formControlName="password"
            class="si-input"
            placeholder="••••••••"
            autocomplete="current-password" />
          <button type="button" class="si-eye-btn" (click)="showPassword = !showPassword">
            <i class="fa-regular" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
          </button>
        </div>
      </div>

      <button type="submit" class="si-submit-btn" [disabled]="form.invalid || loading">
        <app-spinner *ngIf="loading"></app-spinner>
        <span *ngIf="!loading">
          <i class="fa-solid fa-arrow-right-to-bracket"></i>
          <span translate>Se connecter</span>
        </span>
      </button>

    </form>

    <!-- Separator + Signup -->
    <div class="si-separator" *ngIf="!reseller">
      <span translate>Pas encore de compte ?</span>
    </div>
    <a
      *ngIf="!reseller"
      href="https://lms.wefitgroup.com/"
      target="_blank"
      class="si-signup-btn">
      <i class="fa-solid fa-user-plus"></i>
      <span class="si-signup-text" translate>Créer mon compte sur WeFit</span>
      <i class="fa-solid fa-arrow-up-right-from-square si-ext-icon"></i>
    </a>

    <!-- Reseller link -->
    <div class="si-reseller-link" *ngIf="reseller?.link">
      <a (click)="goToOf()" class="pointer" translate
        [translateParams]="{reseller: reseller.name}">reseller.visitSite</a>
    </div>

  </div>
</div>
